module.exports = __webpack_public_path__ + "static/media/icon-error-red.5b80daba.svg";